<div class="fases-container">
    @if(phases){
    <!-- @if (!isBlocked) {
            <div class="multi-select-controls">
                @if (!isMultiSelectMode) {
                    <button class="button is-small is-primary" (click)="toggleMultiSelectMode()">
                        <fa-icon [icon]="faUser"></fa-icon>
                        Cambiar ejecutor
                    </button>
                } @else {
                    <span class="selected-count">{{selectedTasks.length}} tarea(s) seleccionada(s)</span>
                    <button class="button is-small is-success" (click)="openMultipleExecutorModal()" [disabled]="selectedTasks.length === 0">
                        <fa-icon [icon]="faUser"></fa-icon>
                        Cambiar ejecutor
                    </button>
                    <button class="button is-small" (click)="toggleMultiSelectMode()">
                        Cancelar
                    </button>
                }
            </div>
        } -->
    @for(p of phases; track p; let index = $index){
    <div class="fase" [ngClass]="(isAllPhaseDisabled(index) ? isDynamic ? '' :'phase-hide' : '')">
        <div class="fase-title-container" (click)="showFase(index)">
            <div>
                <span class="fase-title">Fase {{p.phase}}</span>
                <span class="tag"
                    [ngStyle]="{'color': phaseState(index)[1], 'background-color': phaseState(index)[1] + '1a'}"><fa-icon
                        [icon]="faCircle"></fa-icon> {{phaseState(index)[0]}} </span>
            </div>
            <div class="fase-actions">
                @if (!isBlocked && !isAllPhaseDisabled(index) && getActiveTasks(p.tasks).length > 0 &&
                hasIncompleteTasks(p) && !isMultiSelectMode) {
                <div class="phase-executor-icon" (click)="openPhaseExecutorModal(p, $event)"
                    title="Cambiar ejecutor de todas las tareas incompletas de esta fase">
                    <fa-icon [icon]="faUser"></fa-icon>
                </div>
                }
                <span class="flecha-desplegar"><fa-icon [icon]="p.show ? faChevronUp : faChevronDown"></fa-icon></span>
            </div>
        </div>
        <hr class="">
        @if (phases[index].show) {
        @if(isDynamic && phaseState(index)[0] === "Bloqueada") {
        <div class="disabled-tasks-text">Las tareas dependen de la respuesta a una tarea anterior</div>
        }
        <div class="tasks columns">
            @for(task of getActiveTasks(p.tasks); track task; let lastIndex = $last; let j = $index){
            @if(!task.isDisabled) {

            <div class="card" [ngStyle]="{'width': 100/getActiveTasks(p.tasks).length+ '%'}"
                [ngClass]="{'is-disabled': task.isDisabled, 'is-finished': task.value || task.value === 0, 'is-active': !task.isDisabled && !task.value }">
                @if (isMultiSelectMode && !task.isDisabled && !task.value && task.value !== 0) {
                <div class="task-checkbox" (click)="$event.stopPropagation()">
                    <p-checkbox [binary]="true" [ngModel]="isTaskSelected(task)" (onChange)="toggleTaskSelection(task)">
                    </p-checkbox>
                </div>
                }
                <div class="card-content">
                    <div [ngStyle]="getNgStylePointer(index)">
                        @if (task.type === 'CHECK'){
                        <label class="checkbox">
                            <p-checkbox class="check" [(ngModel)]="task.value" [binary]="true"
                                (ngModelChange)="selectDeselectPhases(task, p, lastIndex)"
                                [disabled]="task.isDisabled || isBankAccountCheckboxDisabled(task, index) || isMultiSelectMode"
                                [readonly]="isBlocked || isTaskBlocked(index,task.orderId) || isMultiSelectMode" />
                            <span>{{task.name}}</span>
                        </label>
                        } @else if (task.type === 'NUMBER') {
                        <div class="input-container">
                            <span style="padding-bottom: 5px;">{{task.name}}</span>
                            <div style="width: 200px;">
                                <input type="text" class="input"
                                    [ngClass]="(task.value || task.value === 0 ? 'filled' : '')"
                                    [(ngModel)]="task.value" (focus)="onNumberFocus($event, task)"
                                    (blur)="onNumberBlur($event, task); selectDeselectPhases(task, p, lastIndex)"
                                    [disabled]="task.isDisabled || isMultiSelectMode || isImporteDeclaracionDisabled(task)"
                                    [readonly]="isBlocked || isTaskBlocked(index,task.orderId) || isMultiSelectMode">
                            </div>
                        </div>

                        } @else if (task.type === 'INPUT') {
                        <div class="input-container">
                            <span style="padding-bottom: 5px;">{{task.name}}</span>
                            <div style="width: 200px;">
                                <input type="text" class="input" [ngClass]="(task.value ? 'filled' : '')"
                                    [(ngModel)]="task.value"
                                    [disabled]="task.isDisabled || isMultiSelectMode || isImporteDeclaracionDisabled(task)"
                                    [readonly]="isBlocked || isTaskBlocked(index,task.orderId) || isMultiSelectMode"
                                    (change)="selectDeselectPhases(task, p, lastIndex)">
                            </div>
                        </div>

                        } @else if (task.type === 'OPTIONS') {
                        <div class="input-container">
                            <span style="padding-bottom: 5px;">{{task.name}}</span>
                            <div style="width: 200px;">
                                <p-dropdown [options]="task.options" [(ngModel)]="task.value"
                                    [disabled]="task.isDisabled || isMultiSelectMode"
                                    [readonly]="isBlocked || isTaskBlocked(index,j) || isMultiSelectMode"
                                    [showClear]="task.value" [variant]="task.value ? 'filled' : 'outlined'"
                                    (onChange)="selectDeselectPhases(task, p, lastIndex)"
                                    [emptyFilterMessage]="'No se encontraron resultados'">
                                </p-dropdown>
                            </div>
                        </div>
                        }
                    </div>
                    @if (task.executor) {
                    @if (isString(task.executor)) {
                    <div class="executor"
                        [ngClass]="{'executor-disabled': task.value || task.value === 0 || isMultiSelectMode}"
                        (mouseover)="hoveringExecutor = task.executor; hoverTask = j; hoverPhase = index"
                        (mouseout)="hoveringExecutor = null; hoverTask = null; hoverPhase = null"
                        [ngStyle]="{'color': (task.executor && !task.isDisabled && task.value) ? '#5cbc9c' : 'black'}"
                        (click)="(!isBlocked && !task.value && task.value !== 0 && !isMultiSelectMode ? openExecutorModal(task) : '')">
                        <span>
                            <fa-icon class="user-icon" [icon]="faUser"></fa-icon>
                            {{getInitials(task.executor)}}
                        </span>
                        @if (hoveringExecutor === task.executor && hoverPhase === index && hoverTask === j &&
                        !isMultiSelectMode) {
                        <div class="tooltip-container"
                            [ngStyle]="{'background-color': task.value ? '#5cbc9c': 'black'}">
                            {{task.executor}}
                        </div>

                        }
                    </div>
                    } @else {
                    <div class="executor"
                        [ngClass]="{'executor-disabled': task.value || task.value === 0 || isMultiSelectMode}"
                        (mouseover)="hoveringExecutor = task.executor; hoverTask = j; hoverPhase = index"
                        (mouseout)="hoveringExecutor = null; hoverTask = null; hoverPhase = null"
                        [ngStyle]="{'color': (task.executor && !task.isDisabled && task.value) ? '#5cbc9c' : 'black'}"
                        (click)="(!isBlocked && !task.value && task.value !== 0 && !isMultiSelectMode ? openExecutorModal(task) : '')">
                        <span>
                            <fa-icon class="user-icon" [icon]="faUser"></fa-icon>
                            {{getInitials(task.executor[0])}}
                        </span>
                        @if (hoveringExecutor === task.executor && hoverPhase === index && hoverTask === j &&
                        !isMultiSelectMode) {
                        <div class="tooltip-container"
                            [ngStyle]="{'background-color': task.value ? '#5cbc9c': 'black'}">
                            {{task.executor[0]}}
                        </div>

                        }
                    </div>
                    }

                    } @else {
                    <div class="executor"
                        [ngClass]="{'executor-disabled': task.value || task.value === 0 || isMultiSelectMode}"
                        (click)="(!isBlocked && !task.value && task.value !== 0 && !isMultiSelectMode ? openExecutorModal(task) : '')">
                        <span>
                            <fa-icon class="user-icon" [icon]="faUser"></fa-icon>

                        </span>
                    </div>
                    }

                </div>
            </div>
            }
            @if(j < (getActiveTasks(p.tasks).length-1)){ <fa-icon class="next-icon" [icon]="faPlay"></fa-icon>
                }

                }
        </div>
        }
    </div>
    }
    } @else {
    <div class="skeleton-block">
        <div></div>
    </div>
    <div class="skeleton-block">
        <div></div>
    </div>
    <div class="skeleton-block">
        <div></div>
    </div>
    }

</div>

@if (showExecutorModal){
<app-executor-modal [isPhaseMode]="selectedPhase !== null" [isMultipleMode]="selectedTasks.length > 0"
    [taskCount]="selectedTasks.length" (closeEvent)="closeExecutorModal()" (selectEvent)="onExecutorSelect($event)"
    #modal>
</app-executor-modal>
}
@if (showCommentModal){
<app-comment-modal [tasks]="this.modalData" (closeEvent)="closeCommentModal()" (commentEvent)="comment($event)"
    #commentModal></app-comment-modal>
}

@if(isSaving) {
<div class="spinner-overlay">
    <div class="spinner-container">
        <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner" />
    </div>
</div>
}